import { Select } from "nlib/ui";
import { getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DocumentPaymentTypes from "const/DocumentPaymentTypes";
import DocumentTypes from "const/DocumentTypes";
import FieldContainer from "../FieldContainer";
import IntegrationServices from "const/IntegrationServices";
import React, { useCallback, useMemo } from "react";
import useDocumentContext from "hooks/useDocumentContext";

const DOCUMENT_TYPES = {
  [DocumentPaymentTypes.BUY]: {
    [DocumentTypes.INVOICE]: DocumentTypes.BILL,
    [DocumentTypes.RECEIPT]: DocumentTypes.RECEIPT,
    [DocumentTypes.CREDIT_NOTE]: DocumentTypes.CREDIT_NOTE
  },
  [DocumentPaymentTypes.SELL]: {
    [DocumentTypes.INVOICE]: DocumentTypes.INVOICE,
    [DocumentTypes.SALES_RECEIPT]: DocumentTypes.SALES_RECEIPT,
    [DocumentTypes.CREDIT_NOTE]: DocumentTypes.CREDIT_NOTE
  }
};

const DOCUMENT_TYPE_VARIANTS = {
  [DocumentTypes.INVOICE]: { type: DocumentTypes.INVOICE, paymentType: DocumentPaymentTypes.SELL },
  [DocumentTypes.BILL]: { type: DocumentTypes.INVOICE, paymentType: DocumentPaymentTypes.BUY },
  [DocumentTypes.RECEIPT]: { type: DocumentTypes.RECEIPT, paymentType: DocumentPaymentTypes.BUY },
  [DocumentTypes.SALES_RECEIPT]: { type: DocumentTypes.SALES_RECEIPT, paymentType: DocumentPaymentTypes.SELL }
};

const TypeField = (props) => {
  const { uiTexts } = useSelector(getTextsData);

  const {
    extraData: { integrationService } = {}
  } = useSelector(getSelectedBusinessData);

  const {
    documentState: { type, paymentType },
    documentData: { paidTransactions = [] },
    setDocumentState
  } = useDocumentContext();

  const quickBooksBusiness = integrationService === IntegrationServices.QUICK_BOOKS.value;

  const value = DOCUMENT_TYPES?.[paymentType]?.[type];

  const documentTypes = useMemo(() => {
    return [
      DocumentTypes.INVOICE,
      DocumentTypes.BILL,
      DocumentTypes.RECEIPT,
      !!quickBooksBusiness && DocumentTypes.SALES_RECEIPT
    ].filter(Boolean);
  }, [quickBooksBusiness]);

  const options = useMemo(() => {
    return documentTypes.map((item) => ({
      value: item,
      label: uiTexts[item],
      disabled: !!paidTransactions.length && item === DocumentTypes.SALES_RECEIPT
    }));
  }, [uiTexts, documentTypes, paidTransactions]);

  const handleChange = useCallback((documentType) => {
    setDocumentState(DOCUMENT_TYPE_VARIANTS[documentType]);
  }, [setDocumentState]);

  return (
    <FieldContainer
      portal
      id="documentType"
      selectable={false}
      confidenceFields={["type", "paymentType"]}
      invalid={!value || (!!paidTransactions.length && value === DocumentTypes.SALES_RECEIPT)}
      label={uiTexts.type}
      placeholder={uiTexts.selectDocumentType}
      value={value}
      displayValue={uiTexts[value]}
      options={options}
      onChange={handleChange}
      component={Select}
      {...props} />
  );
};

export default React.memo(TypeField);
